export const ACTION_EMAIL_VALIDATION_CODE = '/Account/sendEmailValidationCode';